import { PostContentBlockMap } from 'components/Blocks/index.types';

import { FootNotes } from 'components/EditorBlocks/FootNotes/FootNotes';

const defaultBlockMap: PostContentBlockMap = {
    'core/footnotes': FootNotes,
};

export default defaultBlockMap;
